import { Ref } from "@tblabs/truffle";


export class Router
{
    private history: string[] = [];
    
    public GoToAllDatabasesPage(): void
    {
        this.GoTo(`admin/databases`);
    }
    
    constructor(private hash: Ref<string>)
    { }
    
    private GoTo(path: string): void
    {
        this.hash.value = path;
    }
    
    public GoToLoginPage(): void
    {
        this.GoTo(`login`);
    }
  
    public GoToDatabasePage(db: string): void
    {
        this.GoTo(`admin/database/${db}`);
    }

    public GoBack()
    {
        /*
        TO NIE DZIAŁA:

        history.back(); // cofa adres ale nie przeładowuje strony
        location.reload(); // to też nie przeładowuje
        */
        this.history.pop();
        this.hash.value = this.history.pop() || "jobs";
    }
}

